import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`How can you tell an email or domain really belongs to npm and isn't a phishing attempt? Here's a full list:`}</p>
    <h2>{`Active domains`}</h2>
    <ul>
      <li parentName="ul">{`registry.npmjs.org - the official, default npm registry`}</li>
      <li parentName="ul">{`npmjs.com - the domain of our website and any email from us`}</li>
      <li parentName="ul">{`npm.im - a short domain used to redirect to packages, e.g. npm.im/express`}</li>
      <li parentName="ul">{`npm.me - a short domain used for redirects in marketing campaigns, ads, etc.`}</li>
      <li parentName="ul">{`npm.red - a domain used for staging our website and registry in development`}</li>
    </ul>
    <h2>{`Formerly used`}</h2>
    <ul>
      <li parentName="ul">{`npmcamp.com, npm.camp - for our conference`}</li>
    </ul>
    <h2>{`Idle`}</h2>
    <p>{`We own these but don't use them for anything (yet).`}</p>
    <ul>
      <li parentName="ul">{`npmjs.net`}</li>
      <li parentName="ul">{`npm.rocks`}</li>
      <li parentName="ul">{`npm.tips`}</li>
      <li parentName="ul">{`npm.xyz`}</li>
      <li parentName="ul">{`npm.computer`}</li>
      <li parentName="ul">{`npm.technology`}</li>
      <li parentName="ul">{`npm.today`}</li>
      <li parentName="ul">{`npm.email`}</li>
      <li parentName="ul">{`npm.mn`}</li>
      <li parentName="ul">{`npm.so`}</li>
    </ul>
    <h2>{`Changes`}</h2>
    <p>{`This is a living document and may be updated from time to time.
Please refer to the `}<a parentName="p" {...{
        "href": "https://github.com/npm/documentation/blob/main/content/policies/domains.mdx"
      }}>{`git history for this
document`}</a>{`
to view the changes.`}</p>
    <h2>{`License`}</h2>
    <p>{`Copyright (C) npm, Inc., All rights reserved`}</p>
    <p>{`This document may be reused under a `}<a parentName="p" {...{
        "href": "https://creativecommons.org/licenses/by-sa/4.0/"
      }}>{`Creative Commons
Attribution-ShareAlike
License`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      